import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import OdinIcon, { type OdinIconName } from '../../odin-icon/odin-icon.component';
import { isImageFile, isPdfFile } from './file-utils';

export interface FileActionsProps {
  file: File;
  thumbnail: boolean;
  onRemove: (file: File) => void;
}

export default function FileActions({ file, thumbnail, onRemove }: FileActionsProps) {
  const { t } = useTranslation();

  const itemActionContainerStyles = clsx(
    'odin-hidden group-hover:odin-inline-flex',
    { 'odin-flex-1 odin-justify-evenly': !thumbnail },
    { 'odin-absolute odin-top-0 odin-right-0 odin-py-1 odin-w-full odin-justify-end odin-bg-gray-5': thumbnail }
  );

  const itemActionStyles = clsx(
    'odin-inline-flex odin-cursor-pointer',
    { 'odin-ml-2': !thumbnail },
    { 'odin-mr-2': thumbnail }
  );
  return (
    <div className={itemActionContainerStyles}>
      <div
        title={t('remove', 'Remove')}
        className={itemActionStyles}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onRemove(file);
        }}
      >
        {thumbnail ? <OdinLineIcon icon="Trash" /> : t('remove', 'Remove')}
      </div>

      <a
        title={t('download', 'Download')}
        className={itemActionStyles}
        download={file.name}
        href={window.URL.createObjectURL(file)}
        onClick={(event) => event.stopPropagation()}
      >
        {thumbnail ? <OdinLineIcon icon="Download" /> : t('download', 'Download')}
      </a>

      {(isPdfFile(file.type) || isImageFile(file.type)) && (
        <a
          title="Preview"
          className={itemActionStyles}
          href={window.URL.createObjectURL(file)}
          target="_blank"
          rel="noreferrer"
          onClick={(event) => event.stopPropagation()}
        >
          {thumbnail ? <OdinLineIcon icon="ExternalLink" /> : t('preview', 'Preview')}
        </a>
      )}
    </div>
  );
}

const OdinLineIcon = ({ icon, className }: { icon: OdinIconName; className?: string }) => (
  <OdinIcon icon={icon} className={className} />
);
